(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-siatka"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__chg2Bound) return;
    window.__chg2Bound = true;
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.chg2-dot');
      if (!dot) return;
      e.preventDefault();
      var key = dot.getAttribute('data-key');
      var row = dot.closest('[data-row]');
      if (!row) return;
      row.querySelectorAll('.chg2-card').forEach(function (card) {
        var d = card.querySelector('.chg2-dot[data-key="' + key + '"]');
        if (!d) return;
        card.querySelectorAll('.chg2-dot').forEach(function (x) {
          x.classList.remove('is-on');
          x.setAttribute('aria-pressed', 'false');
        });
        d.classList.add('is-on');
        d.setAttribute('aria-pressed', 'true');
        var img = card.querySelector('.chg2-img');
        if (img && d.dataset.src) {
          img.removeAttribute('loading');
          img.srcset = d.dataset.srcset || '';
          img.src = d.dataset.src;
        }
        var media = card.querySelector('.chg2-media');
        var base = media ? media.getAttribute('data-base') : '';
        var q = '?variant=' + d.dataset.variant;
        card.querySelectorAll('.chg2-media, .chg2-type').forEach(function (a) {
          a.setAttribute('href', base + q);
        });
      });
      var first = row.querySelector('.chg2-card .chg2-media');
      var setlink = row.querySelector('.chg2-setlink');
      if (first && setlink) setlink.setAttribute('href', first.getAttribute('href'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
